export default __webpack_public_path__ + "static/caption-02-cht-bce783f10b1c5e000829f11cd43f140b.png";